(function (module) {

    module.service('forecastConfigurationService', ['$http', forecastConfigurationService])

    function forecastConfigurationService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.getRisks = function () {
            return $http.get('/api/configuration/risks')
                .then(function (response: $TSFixMe) {
                    return response.data;
                });
        };

        service.editRisk = function (entity: $TSFixMe) {
            return $http.post('api/configuration/risks', entity);
        };

        service.addRisk = function (entity: $TSFixMe) {
            return $http.put('api/configuration/risks', entity);
        };

        service.searchCorrectionPrompt = function (searchString: $TSFixMe, source: $TSFixMe) {
            return $http.get('api/configuration/correction-prompt', {
                params: {
                    searchString,
                    source
                }
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

    }

})(angular.module('topline.modules'));